<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      apptArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>

<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter Appointments</mat-label>
        <input
          matInput
          (keyup)="filterAppointments($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="appt-table"
      matSort
      fixedLayout="false"
    >
      <ng-container matColumnDef="appointmentId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID #</th>
        <td mat-cell *matCellDef="let appointment">
          {{ appointment.appointmentId || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let appointment">
          {{ appointment.customer || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="assignedName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Estimator Name
        </th>
        <td mat-cell *matCellDef="let appointment">
          {{ appointment.assignedName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="startTimeUTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
        <td mat-cell *matCellDef="let appointment">
          {{ appointment | appointmentTime : "start" : "MM/dd/yyyy - h:mm a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="endTimeUTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>End Time</th>
        <td mat-cell *matCellDef="let appointment">
          {{ appointment | appointmentTime : "end" : "MM/dd/yyyy - h:mm a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let appointment">
          {{ appointment.jobAddress || "n/a" | titlecase }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching appointments found
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToAppointment(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
